// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2Fryn","location":"Header_location__2KyA6"};